<template>
  <div class="border-t-2 border-red-900 shadow flex overflow-hidden">
    <div class="py-4 px-4 md:px-6">
      <doe-fieldset-heading :label="label" :description="description" />
      <slot/>
    </div>
    <div class="hidden lg:block">
      <img class="overflow-hidden" width="1200px" style="float: right;" src="@/assets/Portal-img.jpg" alt="Early Childhood students squeezing lemons in a veggie garden." />
    </div>
  </div>
</template>

<script>
import DoeFieldsetHeading from "@/components/typography/FieldsetHeading";

export default {
  name: "ImageBanner",
  props: {
    label: {
      required: true
    },
    description: {
      required: false
    },
    image: {
      required: false
    }
  },
  components: {
    DoeFieldsetHeading
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss" scoped></style>